import { HiExclamation } from 'react-icons/hi'

import { Alert, Box, Flex, Icon, SlideFade } from '@chakra-ui/react'

import { Button } from '@/components/ui'

interface DeviceMisconfiguredAlertIProps {
  count: number
  onClick: () => void
}

export const DeviceMisconfiguredAlert = ({
  count,
  onClick,
}: DeviceMisconfiguredAlertIProps) => {
  const doorText = count > 1 ? 'Doors' : 'Door'
  return (
    <SlideFade in>
      <Alert borderRadius='10px' color='red.600' mb={4} status='error'>
        <Icon as={HiExclamation} boxSize='20px' mr='10px' />
        <Box fontSize='14px' fontWeight={500}>
          <Box as='span' fontWeight={600}>
            {count} {`${doorText}`}
          </Box>{' '}
          in this rule do not have the correct configuration
        </Box>
        <Flex flex={1} justifyContent='flex-end'>
          <Button boxShadow='none' onClick={onClick} rounded='10px' size='sm'>
            View {`${doorText}`}
          </Button>
        </Flex>
      </Alert>
    </SlideFade>
  )
}
